import { useEffect, useState, ReactNode } from "react";

import { ToastProvider } from "./toast";
import { env } from "../config/env";
import { TenantProvider } from "../multitenancy/config";
import { initI18nWithTenant } from "../multitenancy/i18n";

interface AppProviderProps {
  children: ReactNode;
}

const AppProvider = ({ children }: AppProviderProps) => {
  const [i18nReady, setI18nReady] = useState(false);

  useEffect(() => {
    initI18nWithTenant(env.PRODUCT_ID, env.CLIENT_ID || undefined).then(() => {
      setI18nReady(true);
    });
  }, []);

  if (!i18nReady) {
    return null;
  }

  return (
    <TenantProvider>
      <ToastProvider>{children}</ToastProvider>
    </TenantProvider>
  );
};

export default AppProvider;
